import { configureStore } from "@reduxjs/toolkit";
import authUserReducer from "../slices/AuthSlice";
import chatUserReducer from "../slices/ChatSlice";
import socketReducer from "../slices/SocketSlice";
import fcmTokenReducer from "../slices/AuthSlice";
import taskReducer from "../slices/TaskSlice";

const store = configureStore({
  reducer: {
    authUser: authUserReducer,
    chatUser: chatUserReducer,
    socket: socketReducer,
    fcmToken: fcmTokenReducer,
    task: taskReducer,
  },
});

export default store;
